<template>
  <div ref="outer" class="relative h-auto min-w-0 overflow-clip" :style="outerStyle">
    <div ref="inner" class="absolute origin-top-left">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue';
import { useResizeObserver } from '@vueuse/core';

const outer = ref<HTMLElement | null>(null);
const inner = ref<HTMLElement | null>(null);

const scale = ref(1);
const height = ref<number | null>(null);

const updateScale = async () => {
  if (!outer.value || !inner.value) return;
  inner.value.style.width = '';
  inner.value.style.transform = '';
  await nextTick();
  const outerWidth = outer.value.offsetWidth;
  const innerWidth = inner.value.scrollWidth;
  if (innerWidth === 0) return;
  scale.value = Math.min(outerWidth / innerWidth, 1);
  inner.value.style.transform = `scale(${scale.value})`;
  inner.value.style.width = scale.value !== 1 ? `${100 / scale.value}%` : '';
  inner.value.style.display = 'inline-block';
  height.value = inner.value.scrollHeight * scale.value;
};

useResizeObserver(outer, updateScale);
useResizeObserver(inner, updateScale);

watch([outer, inner], updateScale);

const outerStyle = computed(() => ({
  height: height.value ? `${height.value}px` : undefined,
}));
</script>
